// Shared by capture, presentation and server authorization. GeoJSON is lng/lat;
// legacy Leaflet arrays are lat/lng. Never substitute a demonstration boundary.
export function boundaryPolygons(boundary) {
  try {
    let b = typeof boundary === 'string' ? JSON.parse(boundary) : boundary;
    if (b?.type === 'Feature') b = b.geometry;
    if (b?.type === 'Polygon') return [b.coordinates];
    if (b?.type === 'MultiPolygon') return b.coordinates;
    if (Array.isArray(b)) {
      const rings = typeof b[0]?.[0] === 'number' ? [b] : b;
      return [rings.map(ring => ring.map(([lat, lng]) => [lng, lat]))];
    }
  } catch { /* An unknown boundary never qualifies a position. */ }
  return [];
}
const cross = (a,b) => a[0]*b[1]-a[1]*b[0];
const onEdge = (p,a,b) => Math.abs(cross([p[0]-a[0],p[1]-a[1]],[b[0]-a[0],b[1]-a[1]]))<1e-12 && p[0]>=Math.min(a[0],b[0])-1e-12 && p[0]<=Math.max(a[0],b[0])+1e-12 && p[1]>=Math.min(a[1],b[1])-1e-12 && p[1]<=Math.max(a[1],b[1])+1e-12;
function inRing(p,ring) {
  if(!Array.isArray(ring)||ring.length<3)return false;
  let inside=false;
  for(let i=0,j=ring.length-1;i<ring.length;j=i++){
    const a=ring[i],b=ring[j];
    if(onEdge(p,a,b))return true;
    if((a[1]>p[1])!==(b[1]>p[1])&&p[0]<(b[0]-a[0])*(p[1]-a[1])/(b[1]-a[1])+a[0])inside=!inside;
  }return inside;
}
export function insideProperty(boundary,lat,lng) {
  if(!Number.isFinite(lat)||!Number.isFinite(lng)||Math.abs(lat)>90||Math.abs(lng)>180)return false;
  return boundaryPolygons(boundary).some(rings=>inRing([lng,lat],rings[0])&&!rings.slice(1).some(ring=>inRing([lng,lat],ring)));
}
export function segmentInsideProperty(boundary,a,b) {
  if(!insideProperty(boundary,a.lat,a.lng)||!insideProperty(boundary,b.lat,b.lng))return false;
  const p=[a.lng,a.lat],d=[b.lng-a.lng,b.lat-a.lat],cuts=[0,1];
  for(const rings of boundaryPolygons(boundary))for(const ring of rings)for(let i=0;i<ring.length;i++){
    const q=ring[i],r=ring[(i+1)%ring.length],e=[r[0]-q[0],r[1]-q[1]],v=[q[0]-p[0],q[1]-p[1]],den=cross(d,e);
    if(Math.abs(den)<1e-16)continue;
    const t=cross(v,e)/den,u=cross(v,d)/den;
    if(t>0&&t<1&&u>=0&&u<=1)cuts.push(t);
  }
  cuts.sort((x,y)=>x-y);
  return cuts.every((t,i)=>i===0||insideProperty(boundary,p[1]+d[1]*(t+cuts[i-1])/2,p[0]+d[0]*(t+cuts[i-1])/2));
}
export function distanceMeters(a,b) {
  const r=Math.PI/180,dlat=(b.lat-a.lat)*r,dlng=(b.lng-a.lng)*r;
  const h=Math.sin(dlat/2)**2+Math.cos(a.lat*r)*Math.cos(b.lat*r)*Math.sin(dlng/2)**2;
  return 6371008.8*2*Math.asin(Math.sqrt(Math.min(1,h)));
}
export const DEFAULT_GPS_SETTINGS={lastKnownTtlMinutes:240,onPropertyZoomIncrease:2};
